export function getAuthCode(state) {
  if (state == null) {
    return null
  }
  const { user } = state
  if (user == null) {
    return null
  }
  const { authorization } = user
  if (authorization == null) {
    return null
  }
  return authorization.accessToken
}

export function getCompanyCode(state) {
  if (state == null) {
    return null
  }
  const { user } = state
  if (user == null) {
    return null
  }
  const { companyCode } = user
  if (companyCode == null) {
    return null
  }
  return companyCode
}
